import { CustomerAddress } from 'src/app/public/store/types/CustomerSocialLogin';

export enum DayType {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  TOMORROW = 'TOMORROW',
  DEFAULT = 'DEFAULT',
}

export class Utils {
  // returns ISO date string of day start from input date string
  public static getDayStart(inputDateStr: string) {
    const inputDate = new Date(inputDateStr);

    const startDate = new Date(inputDate);
    startDate.setHours(0, 0, 0, 0);

    return startDate.toISOString();
  }

  // returns ISO date string of day end from input date string
  public static getDayEnd(inputDateStr: string) {
    const inputDate = new Date(inputDateStr);

    const endDate = new Date(inputDate);
    endDate.setHours(23, 59, 59, 999);

    return endDate.toISOString();
  }

  public static dayCheck(inputDateStr: string) {
    const inputDate = new Date(inputDateStr);
    const inputDateYMD =
      inputDate.getFullYear() +
      '-' +
      (inputDate.getMonth() + 1) +
      '-' +
      inputDate.getDate();

    const today = new Date();
    const todayYMD =
      today.getFullYear() +
      '-' +
      (today.getMonth() + 1) +
      '-' +
      today.getDate();

    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const yesterdayYMD =
      yesterday.getFullYear() +
      '-' +
      (yesterday.getMonth() + 1) +
      '-' +
      yesterday.getDate();

    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowYMD =
      tomorrow.getFullYear() +
      '-' +
      (tomorrow.getMonth() + 1) +
      '-' +
      tomorrow.getDate();

    if (inputDateYMD === todayYMD) {
      return DayType.TODAY;
    } else if (inputDateYMD === yesterdayYMD) {
      return DayType.YESTERDAY;
    } else if (inputDateYMD === tomorrowYMD) {
      return DayType.TOMORROW;
    } else {
      return DayType.DEFAULT;
    }
  }

  /* Note: this is not SMART function
   ** returns '01' from 1, assumes input is in range of 0 ~ 59
   */
  public static padNumber(value) {
    const valueStr = value.toString();
    if (valueStr.length > 1) {
      return valueStr;
    }
    return `0${valueStr}`;
  }

  public static isDateLimitValid(input: Date, min: Date, max: Date = null) {
    const inputTime = input.getTime();
    const minTime = min.getTime();
    if (max) {
      const maxTime = max.getTime();
      if (inputTime > minTime) {
        return inputTime < maxTime;
      } else {
        return false;
      }
    } else {
      return inputTime > minTime;
    }
  }

  public static scrollTop(delay: number) {
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), delay);
  }

  public static mapCustomerStatus(customerStatus: any) {
    const defaultStatus = 'UNIDENTIFIED';
    let status = customerStatus;

    if (
      typeof customerStatus === 'object' &&
      !Array.isArray(customerStatus) &&
      customerStatus !== null &&
      Object.keys(customerStatus)
    ) {
      const mapString = [
        customerStatus.identified ? 1 : 0,
        customerStatus.registered ? 1 : 0,
        customerStatus.hasLoyalty ? 1 : 0,
      ].join('');
      const mapKey: any = {
        '111': 'IDENTIFIED_AND_REGISTERED_WITH_LOYALTY',
        '101': 'IDENTIFIED_WITH_LOYALTY',
        '110': 'IDENTIFIED_AND_REGISTERED',
      };
      //Do not access Object.prototype method 'hasOwnProperty'
      //https://eslint.org/docs/latest/rules/no-prototype-builtins
      status = Object.prototype.hasOwnProperty.call(mapKey, mapString)
        ? mapKey[mapString]
        : defaultStatus;
    }
    return typeof status === 'string' || status instanceof String
      ? status
      : defaultStatus;
  }

  public static generateCustomerStorageKey(customer: any) {
    if (customer.id) {
      return customer.id.toString();
    }

    const customerStringArray = [
      (customer.email || '').toString(),
      (customer.name || '').toString(),
      (customer.phoneNumber || '').toString(),
    ]
      .join('')
      .replace(/[^0-9a-zA-Z]/g, '')
      .replace(/\s+/g, '')
      .toLowerCase()
      .trim();
    return [...customerStringArray].sort().reverse().join('');
  }
  /**
   * The customer's id from the saved state stored under their customer_ref,
   * or undefined for a guest. customer_ref itself is only the id for
   * identified customers; for a guest it is the key built above, never an id.
   */
  public static getIdentifiedCustomerId(savedState: any): number | undefined {
    return Number(savedState?.customerId) || undefined;
  }
  public static mapCustomerParamKey(customer: any) {
    const customerInfo = customer ? { ...customer } : {};
    const customerParams = {};
    if (customerInfo.id) {
      if (customerInfo.isUnidentified) {
        customerParams['id'] = customerInfo.id;
      } else {
        customerParams['customerId'] = customerInfo.id;
      }
      return customerParams;
    }
    if (customerInfo.email) {
      customerParams['email'] = customerInfo.email;
    }
    if (customerInfo.name) {
      customerParams['name'] = customerInfo.name;
    }
    if (customerInfo.phoneNumber) {
      customerParams['phoneNumber'] = customerInfo.phoneNumber;
    }
    return customerParams;
  }

  public static formatAddress(address: CustomerAddress): string {
    if (!address) {
      return '';
    }

    const { floorNumber, doorbell, streetAddress, city, postCode } = address;
    const prefix = [floorNumber, doorbell].filter(Boolean).join(' ');
    return [prefix, streetAddress, city, postCode].filter(Boolean).join(', ');
  }

  public static getLocalizedDatePattern(
    dateValue: string,
    basePattern: string,
    isJapanese: boolean = false,
  ): string {
    if (!dateValue) return basePattern;
    const date = new Date(dateValue);
    const dateYear = date.getFullYear();
    const currentYear = new Date().getFullYear();
    if (dateYear !== currentYear) {
      return isJapanese ? `YYYY ${basePattern}` : `${basePattern} YYYY`;
    }
    return basePattern;
  }
}
